export default __webpack_public_path__ + "static/media/image-19.13abbd96.png";